import { CLEAR_AVAILABLE_EMPLOYEES_DELEGATION } from "../../../../enums/MyDivision/Delegation/AuthorityDelegation.types";

export const clearAvailableEmployeesDelegationAction = () => {
    return {
        type: CLEAR_AVAILABLE_EMPLOYEES_DELEGATION,
    };
};